/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_FailedInputs */

const en_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to auto format events`)
};

const fr_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l’auto-formatage des événements`)
};

const de_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung der Ereignisse fehlgeschlagen`)
};

const it_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile formattare automaticamente gli eventi`)
};

const ru_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось выполнить автоматическое форматирование событий.`)
};

const es_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron formatear automáticamente los eventos`)
};

const zh_cn2_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化事件失败`)
};

const ja_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの自動フォーマットに失敗しました`)
};

const hi_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट्स को ऑटो फॉर्मेट करने में विफलता`)
};

const pt_pt2_auto_format_failed = /** @type {(inputs: Auto_Format_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao formatar eventos automaticamente`)
};

/**
* | output |
* | --- |
* | "Failed to auto format events" |
*
* @param {Auto_Format_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_failed = /** @type {((inputs?: Auto_Format_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_failed(inputs)
	if (locale === "de") return de_auto_format_failed(inputs)
	if (locale === "it") return it_auto_format_failed(inputs)
	if (locale === "ru") return ru_auto_format_failed(inputs)
	if (locale === "es") return es_auto_format_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_failed(inputs)
	if (locale === "ja") return ja_auto_format_failed(inputs)
	if (locale === "hi") return hi_auto_format_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_failed(inputs)
	return en_auto_format_failed(inputs)
});